import { z } from "zod";

export const getProjectInvoiceSchema = z.object({
	projectId: z.string().uuid(),
	invoiceId: z.string().uuid(),
});
